import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomVolume = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path d="M2.3335 6.33333H3.66683V13H2.3335V6.33333Z" fill="currentColor" />
        <path d="M5.66683 1H7.00016V13H5.66683V1Z" fill="currentColor" />
        <path d="M9.00016 8.33333H10.3335V13H9.00016V8.33333Z" fill="currentColor" />
        <path d="M12.3335 4.33333H13.6668V13H12.3335V4.33333Z" fill="currentColor" />
    </SvgIcon>
);
